<div class="ui inverted dimmer" [class.active]='loading'>
    <div class="ui text loader">Loading</div>
</div>

<div class="jumbotron bg-white text-center p-0 m-0 ">
    <h1 class="display-4">Corona Covid-19 Tracker Country Wise</h1>
    <hr>

    <div class="mx-auto">
        <div class="form-group col-lg-5 mx-auto">
            <label for="c">Select Country</label>
            <select name="" class="form-control" id="c" #input (change)='updateValues(input.value)'>
                <option value="{{con}}" *ngFor='let con of countries'>{{con}}</option>
            </select>
        </div>
    </div>
    <app-dashboard-card [totalConfirmed]='totalConfirmed' [totalActive]='totalActive' [totalRecovered]='totalRecovered' [totalDeaths]='totalDeaths'></app-dashboard-card>


    <div class="row">

        <div class="col">

            <table class="table">
                <thead>
                    <tr>
                        <th>SrNo.</th>
                        <th>Date</th>
                        <th>Cases</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor='let cs of selectedCountryData; index as i '>
                        <td>{{i+1}}</td>
                        <td>{{cs.date | date}}</td>
                        <td>{{cs.cases}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col">
            <google-chart [type]='chart.LineChart' [options]='chart.options' style="width: 100%;" [height]='chart.height' [data]='datatable'></google-chart>
        </div>

    </div>
</div>